export default "__VITE_ASSET__0ytkriGe__"